// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3810f9","723":"bcafa00c","983":"2e23f01d"}[chunkId] + ".chunk.js";
};